import EquityCurve from "./EquityCurve";

const Equitycurve = ({
  calculateFields,
  trades,
}) => {
  return <Equitycurve calculateFields={calculateFields} />;
};

export default EquityCurve;
